<template>
  <div class="initiative-post">
    <div class="post-header">
      <div class="shadow"></div>
      <h1>{{ currentInit[0].title }}</h1>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="mt-5">
            <p>
              {{ currentInit[0].text }}
            </p>
            <!-- <p>
                Here goes our top 20 Doodles from the Dream-a-Doodle contest. We congratulate each one of you for creating such powerful artworks. Each doodle is a story of your hard work and perseverance. It is indeed empowering to see such amazing creative young minds. We celebrate your dream and we believe that with wonderful dreamers like you around, the World will always be compassionate and wonderful. 
            </p>
            <p>
              Keep dreaming, keep doodling, keep inspiring. You all are what keeps the Earth alive. Thank you again.
            </p> -->
          </div>
          
          <div v-if="!!currentInit[0].video" class="post-video">
            <iframe
              :src="currentInit[0].video"
              width="100%"
              height="580"
              allow="autoplay"
              class="video"
            ></iframe>
          </div>
          <div class="post-gallery">
            <div class="text-center">
              <h2 class="my-5">Artworks</h2>
            </div>
            <silentbox-group style="text-align:center">
              <div
                v-for="(image, index) in currentInit[0].images"
                :key="image.index"
                class="image"
              >
                <silentbox-item
                  :src="image"
                  description="Metropolis Asia"
                  style="height:100%"
                >
                  <img v-lazy="image" style="width:100%; height:100%" />
                </silentbox-item>
              </div>
            </silentbox-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        currentInit:[],
        initiatives: [
            {
                slug: 'doodle-a-dream',
                title:'Doodle-A-Dream',
                text: 'Here goes our top 20 Doodles from the Dream-a-Doodle contest. We congratulate each one of you for creating such powerful artworks. Each doodle is a story of your hard work and perseverance. It is indeed empowering to see such amazing creative young minds. We celebrate your dream and we believe that with wonderful dreamers like you around, the World will always be compassionate and wonderful.  Keep dreaming, keep doodling, keep inspiring. You all are what keeps the Earth alive. Thank you again.',
                video:"",
                images: [
                    require("../assets/images/doodle/1.jpg"),
                    require("../assets/images/doodle/2.jpg"),
                    require("../assets/images/doodle/3.jpg"),
                    require("../assets/images/doodle/4.jpg"),
                    require("../assets/images/doodle/5.jpg"),
                    require("../assets/images/doodle/6.jpg"),
                    require("../assets/images/doodle/7.jpg"),
                    require("../assets/images/doodle/8.jpg"),
                    require("../assets/images/doodle/9.jpg"),
                    require("../assets/images/doodle/13.jpg"),
                    require("../assets/images/doodle/14.jpg"),
                    require("../assets/images/doodle/15.jpg"),
                    require("../assets/images/doodle/16.jpg"),
                    require("../assets/images/doodle/17.jpg"),
                    require("../assets/images/doodle/18.jpg"),
                    require("../assets/images/doodle/19.jpg"),
                    require("../assets/images/doodle/20.jpg"),
                    require("../assets/images/doodle/21.jpg"),
                    require("../assets/images/doodle/22.jpg"),
                    require("../assets/images/doodle/23.jpg"),
                ],
            },
            {
                slug: 'artyard',
                title:'Artyard Chapter II: Verse in Motion',
                text:'We dedicate #ARTYARD to all the Artists. Nothing is empowering than the power to express creatively. Thank you for being the Artist. You are the hope and the light that keeps the Earth alive even in the most difficult of times. In an isolated present, boxed in, awaiting an uncertain future, there is a longing for hope, for freedom. The lockdown was a time for reflection and to imagine a world of compassion, beauty and creativity. #ARTYARD is an idea born out of isolation. It is a feeling to celebrate in confinement yet stay connected, a need to create space and to give Art its own address. #ARTYARD is a wish to see all things beautiful and celebrate its essence. Artyard is to imagine an exhibit in isolation and let Nature be the curator and the only spectator. #ARTYARD is our definition of joy amidst chaos. It a humble first attempt by Metropolis Asia created with a lot of love to celebrate independent Art and Artists and to feel the beauty of creativity without being physically present.',
                video:"https://drive.google.com/file/d/17hkMIgF_NpKQNO98kci7HOUCpj29O3Ds/preview",
                images: [
                    require("../assets/images/artyard/1.jpg"),
                    require("../assets/images/artyard/2.jpg"),
                    require("../assets/images/artyard/3.jpg"),
                    require("../assets/images/artyard/4.jpg"),
                    require("../assets/images/artyard/5.jpg"),
                    require("../assets/images/artyard/6.jpg"),
                    require("../assets/images/artyard/7.jpg"),
                    require("../assets/images/artyard/8.jpg"),
                    require("../assets/images/artyard/9.jpg"),
                    require("../assets/images/artyard/10.jpg"),
                    require("../assets/images/artyard/11.jpg"),
                    require("../assets/images/artyard/12.jpg"),
                   
                ],
            }
        ],
    };
  },
  mounted(){
      console.log(this.$route.params.slug)
      this.currentInit = this.initiatives.filter((i) => i.slug == this.$route.params.slug)
  }
};
</script>

<style scoped>
.initiative-post {
  margin-top: 60px;
  font-size: 18px;
  line-height: 30px;
}

.post-header {
  height: 40vh;
  background: url("https://image.shutterstock.com/image-vector/cartoon-vector-doodles-cosmic-horizontal-260nw-1022577565.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.post-video {
  margin-top: 50px;
}

.post-header::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(3, 3, 3, 0.493);
}

.post-header h1 {
  font-size: 40px;
  color: white;
  z-index: 2;
}

.initiative-post h2 {
  font-size: 36px;
}

.video {
  border: none;
  outline: none;
  border-radius: 5px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

.image {
  display: inline-block;
  /* background-size: cover;
    background-repeat: no-repeat;
    background-position: center center; */
  /* border: 1px solid #ebebeb; */
  /* margin-right: 1px;
    margin-left: 1px; */
  /* width:25%; */
  height: 370px;
  margin-bottom: 20px;
  /* max-height: 250px; */
  flex: 1;
}

.image {
  margin: 5px 5px;
}

.image > span > img {
  object-fit: contain;
  object-position: center;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

@media (max-width: 768px) {
  .image {
    display: inline-block;
    flex: 1;
    width: 43%;
    height: auto;
  }
}
</style>
